import { Link } from "@tanstack/react-router";
import { Users, User } from "lucide-react";
import { cn } from "@/lib/utils/common";

interface SettingsMenuItem {
  title: string;
  description: string;
  href: string;
  icon: React.ComponentType<{ className?: string }>;
}

const settingsMenuItems: SettingsMenuItem[] = [
  {
    title: "Profile",
    description: "Manage your personal information and account settings",
    href: "/settings/profile",
    icon: User,
  },
  {
    title: "Users",
    description: "Manage users, roles, and permissions",
    href: "/settings/users",
    icon: Users,
  },
];

export function SettingsMenu() {
  return (
    <nav className="grid gap-6 sm:grid-cols-2 max-w-4xl">
      {settingsMenuItems.map((item) => {
        const Icon = item.icon;
        return (
          <Link
            key={item.href}
            to={item.href}
            className={cn(
              "group flex flex-col gap-3 rounded-lg border p-6",
              "hover:border-primary/50 hover:bg-accent/50",
              "transition-colors duration-200",
            )}
          >
            <div className="flex items-center gap-3">
              <Icon className="h-5 w-5 text-muted-foreground group-hover:text-primary transition-colors" />
              <h3 className="font-medium">{item.title}</h3>
            </div>
            <p className="text-sm text-muted-foreground">{item.description}</p>
          </Link>
        );
      })}
    </nav>
  );
}
